import { CheckoutCompletedOffer } from './checkout-completed-offer.interface';
import { CheckoutCompletedQuote } from './checkout-completed-quote.interface';
import { CheckoutCompletedRenewal } from './checkout-completed-renewal.interface';

export type CheckoutCompletedItem =
  | CheckoutCompletedQuote
  | CheckoutCompletedOffer
  | CheckoutCompletedRenewal;
